import { Container, RedirectButton, StyledAccordion, Title } from './styles';
import { AccordionInterface } from '@veneer/core';

type FaqProps = AccordionInterface & {
  handleClick: () => void;
  title?: string;
  redirectText?: string;
};

export const Faq = (props: FaqProps) => {
  const {
    handleClick,
    items,
    onExpand,
    onCollapse,
    gutter,
    behavior,
    title,
    redirectText,
  } = props;

  return (
    <Container>
      <Title className="title-regular">{title}</Title>
      <StyledAccordion
        items={items}
        gutter={gutter ?? '16px'}
        background="filled"
        onExpand={onExpand}
        onCollapse={onCollapse}
        behavior={behavior ?? 'singleExpand'}
      />
      <RedirectButton
        appearance="secondary"
        onClick={handleClick}
        data-testid="view-all-faq-button"
      >
        {redirectText}
      </RedirectButton>
    </Container>
  );
};
